import { TEST_IDS } from "./TestIds";
import { TRANSLATION_KEYS } from "./TranslationKeys";

import type { ToastProps } from "components/toasts/MessageToast";

export const USER_TOASTS_IDS = {
  createFailure: TEST_IDS.userCreateFailureToast,
  createSuccess: TEST_IDS.userCreateSuccessToast,
  formValidationFailure: TEST_IDS.userFormValidationFailureToast,
  editFailure: TEST_IDS.userEditFailureToast,
  editSuccess: TEST_IDS.userEditSuccessToast,
  scaRemovalSuccess: TEST_IDS.scaRemovalSuccessToast,
  scaRemovalFailure: TEST_IDS.scaRemovalFailureToast,
  passwordResetSuccess: TEST_IDS.passwordResetSuccessToast,
  passwordResetFailure: TEST_IDS.passwordResetFailureToast,
  promoteUserToOwnerSuccess: TEST_IDS.promoteToOwnerSuccessToast,
  promoteUserToOwnerFailure: TEST_IDS.promoteToOwnerFailureToast,
  demoteUserFromOwnerSuccess: TEST_IDS.demoteUserFromOwnerSuccessToast,
  demoteUserFromOwnerFailure: TEST_IDS.demoteUserFromOwnerFailureToast,
} as const;

export const USER_TOASTS = {
  createUserSuccess: (message: string): ToastProps => ({
    bodyContent: message,
    variant: "success",
    config: {
      toastId: USER_TOASTS_IDS.createSuccess,
      updateId: "user-create-success-update-id",
    },
  }),
  createUserFailure: (message: string): ToastProps => ({
    bodyContent: message,
    variant: "failure",
    config: {
      toastId: USER_TOASTS_IDS.createFailure,
      updateId: "user-create-failure-update-id",
    },
  }),
  formValidationFailure: (message: string): ToastProps => ({
    bodyContent: message,
    variant: "failure",
    config: {
      toastId: USER_TOASTS_IDS.formValidationFailure,
      updateId: "user-form-validation-failure-update-id",
    },
  }),
  editUserSuccess: (
    message: string = TRANSLATION_KEYS.theUserHasBeenModified
  ): ToastProps => ({
    bodyContent: message,
    variant: "success",
    config: {
      toastId: USER_TOASTS_IDS.editSuccess,
      updateId: "user-edit-success-update-id",
    },
  }),
  editUserFailure: (message: string): ToastProps => ({
    bodyContent: message,
    variant: "failure",
    config: {
      toastId: USER_TOASTS_IDS.editFailure,
      updateId: "user-edit-failure-update-id",
    },
  }),
  passwordResetFailure: {
    variant: "failure",
    bodyContent: TRANSLATION_KEYS.couldNotResetThePassword,
    config: {
      toastId: USER_TOASTS_IDS.passwordResetFailure,
      updatedId: "user-password-reset-failure-id",
    },
  },
  passwordResetSuccess: {
    variant: "success",
    bodyContent: TRANSLATION_KEYS.passwordHasBeenSuccessfullyReset,
    config: {
      toastId: USER_TOASTS_IDS.passwordResetSuccess,
      updatedId: "user-password-reset-success-id",
    },
  },
  scaRemovalSuccess: {
    bodyContent: TRANSLATION_KEYS.scaHasBeenSuccessfullyRemovedForThisUser,
    variant: "success",
    config: {
      toastId: USER_TOASTS_IDS.scaRemovalSuccess,
      updateId: "user-sca-removal-success-id",
    },
  },
  scaRemovalFailure: {
    bodyContent: TRANSLATION_KEYS.couldNotRemoveSca,
    variant: "failure",
    config: {
      toastId: USER_TOASTS_IDS.scaRemovalFailure,
      updateId: "user-sca-removal-failure-id",
    },
  },
  promoteUserToOwnerSuccess: {
    bodyContent: TRANSLATION_KEYS.theUserHasBeenPromotedToOwner,
    variant: "success",
    config: {
      toastId: USER_TOASTS_IDS.promoteUserToOwnerSuccess,
      updateId: "user-promote-to-owner-success-update-id",
    },
  },
  promoteUserToOwnerFailure: {
    bodyContent: TRANSLATION_KEYS.theUserCouldNotBePromotedToOwner,
    variant: "failure",
    config: {
      toastId: USER_TOASTS_IDS.promoteUserToOwnerFailure,
      updateId: "user-promote-to-owner-failure-update-id",
    },
  },
  demoteUserFromOwnerSuccess: {
    bodyContent: TRANSLATION_KEYS.userHadBeenDemotedToStandardUser,
    variant: "success",
    config: {
      toastId: USER_TOASTS_IDS.demoteUserFromOwnerSuccess,
      updateId: "user-demoted-from-owner-success-id",
    },
  },
  demoteUserFromOwnerFailure: {
    bodyContent: TRANSLATION_KEYS.userCouldNotBeDemotedToStandardUser,
    variant: "failure",
    config: {
      toastId: USER_TOASTS_IDS.demoteUserFromOwnerFailure,
      updateId: "user-demoted-from-owner-failure-id",
    },
  },
} as const;
